import { BottomNavbar } from "../components/BottomNavbar";
import { Header } from "../components/Header";
import { Metrics } from "../components/Metrics";
// import { SearchBar } from "../components/SearchBar";
import { DateRange } from "../components/DateRange";
import { SessionOptions } from "../components/Grouplist";
import { Sessions } from "../components/Sessions";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// function redux
import { setYourMetrics } from "../redux/yourMetrics_SliceReducer";

//API
import { getYourMetric } from "../components/funtionsBD/home/yourMetrics";

export function Adminhome() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [token] = useState(localStorage.getItem("token"));
  const userName = useSelector((state) => state.user.name);
  const cardData = useSelector((state) => state.yourMetrics.cars);

  // Check if a user is already stored in localStorage
  // useEffect(() => {
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   if (!user) {
  //     logout(token);
  //     navigate("/");
  //   } else {
  //     dispatch(setUserName(user.user_first_name));
  //   }
  // }, [navigate]);

  const getYourMetricLocal = async () => {
    const cards = await getYourMetric();
    dispatch(setYourMetrics(cards));
  };
  useEffect(() => {
    if (!cardData || cardData.length === 0) {
      getYourMetricLocal();
    }
  }, []);

  return (
    <>
      <div id="adminRoot">
        <Header userName={userName} />
        {/* <SearchBar /> */}
        <Metrics cardData={cardData} />
        <DateRange />
        <SessionOptions />
        <Sessions />
      </div>
    </>
  );
}
